<div class="branches-main content-web-section">
  <div class="col-lg-12 row tabs-group">
    <div class="col-lg-1">
    </div>
      <div class="col-lg-10 ">
        <div class="col-lg-12 col-md-12 row">
          <div class="col-lg-1 col-md-1 col-xs-12"></div>
          <div class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer radius-left text-center" [ngClass]="{'active-tab':activeTab==='north'}"  (click)="setActive('north')">
            North
            <span class="tab-seperator"></span>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer text-center" [ngClass]="{'active-tab':activeTab==='south'}"  (click)="setActive('south')">
           South
           <span class="tab-seperator"></span>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer text-center" [ngClass]="{'active-tab':activeTab==='east'}"  (click)="setActive('east')">
           East
           <span class="tab-seperator"></span>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer radius-right text-center" [ngClass]="{'active-tab':activeTab==='west'}"  (click)="setActive('west')">
            West
          </div>
          <div class="col-lg-1 col-md-1 col-xs-12"></div>
        </div>
      </div>
      <div class="col-lg-1">
        </div>
    </div>

    <div class="col-lg-12 row data-section">
      <div class="col-lg-3 tabs-section">
        <div *ngFor="let item of data;let i=index">
          <div class="question-tabs cursor-pointer" (click)="setActiveState(i)"
            [ngClass]="{'active-tab-button2':i===activeTopicId}">
            <a class="tab-btn-text2">{{item.state}}</a>
          </div>
        </div>
      </div>
      <div class="col-lg-9 answer-section">
        <div class="article-heading2" *ngIf="data.length>0 && data[activeTopicId].returnList">{{ data[activeTopicId].state}} </div>
        <div class="answwer-content" >
          <div class="col-lg-12 row file-list-section " *ngIf="data.length>0 && data[activeTopicId].returnList">
                  <div class="col-lg-6 pl-3 "  *ngFor="let item of data[activeTopicId].returnList;let i=index"
                  [ngClass]="{'border-top': i!==0 && i!==1 }">
                  <div *ngIf="router.url === '/karvy-branches'" >
                    <div class="text-answer-section top-line" >KFin Technologies Limited </div>
                    <img src="assets/icons/icon_address.png" width="4%" class="mt-2">&nbsp;
                    <div class="text-answer-section adrs-custom">

                      {{item.address}}
                    </div>
                    <div class="text-answer-section" >
                      <img src="assets/icons/icon_email_black.png" width="5%">&nbsp;
                      <u>{{item.officeEmail}} </u>
                    </div>
                    <div class="text-answer-section">
                      <img src="assets/icons/icon_phone_black.png" width="5%">&nbsp;
                      {{item.phoneNo}}
                    </div>
                    <div class="text-answer-section" *ngIf="item.contactName">
                      <img src="assets/icons/icon_name.png" width="5%">&nbsp;
                      {{item.contactName}} <br>
                      &nbsp;&nbsp;&nbsp;&nbsp;<span  *ngIf="!item.agentNo" > <u>{{item.emailId}} </u></span>
                    </div>
                  </div>
                  <div  *ngIf="router.url === '/amc-branches'">
                    <div class="text-answer-section ">
                      {{item.address}}
                    </div>
                  </div>
                  <div *ngIf="router.url === '/locate-advisor'">
                    <div class="text-answer-section" *ngIf="item.agentNo">
                      <span class="sub-header"> Agent No</span> :
                      <span class="sub-text">{{item.agentNo}}</span>
                    </div>
                    <div class="text-answer-section" *ngIf="item.agentName">
                      <span class="sub-header">Agent Name</span> :
                      <span class="sub-text">{{item.agentName}}</span>
                    </div>
                    <div class="text-answer-section" *ngIf="item.city">
                      <span class="sub-header">City </span> :
                      <span class="sub-text">{{item.city}}</span>
                    </div>
                    <div class="text-answer-section" *ngIf="item.pinCode">
                      <span class="sub-header">Pin Code</span> :
                      <span class="sub-text">{{item.pinCode}}</span>
                    </div>
                    <div class="text-answer-section" *ngIf="item.mobile">
                      <span class="sub-header">Mobile No</span> :
                      <span class="sub-text">{{item.mobile}}</span>
                    </div>
                    <div class="text-answer-section" *ngIf="item.emailId">
                      <span class="sub-header">Email </span> :
                      <span class="sub-text">{{item.emailId}}</span>
                    </div>

                  </div>
                    <br> <br>
                </div>
          </div>
          <div class="col-lg-12" *ngIf="data.length<=0 || !data[activeTopicId].returnList">
            No data available
          </div>
        </div>
      </div>
    </div>

</div>


<div class="branches-main content-mobile-section">
  <div class="col-lg-12 row tabs-group">
    <div class="col-lg-12  row tab-pad">
      <select  class="select-data" [(ngModel)]="activeTab" (change)="getData()">
        <option value="north">North</option>
        <option value="south"> South</option>
        <option value="east"> East</option>
        <option value="west"> West</option>
      </select>
    </div>
   
    </div>

    <div class="col-lg-12 row data-section">
      <select  class="select-data" [(ngModel)]="activeTopicId" >
        <option disabled>Please select</option>
        <option [value]="i" *ngFor="let item of data;let i=index">{{item.state}}</option>
      </select>
    </div>
      <div class="col-12 answer-section">
        <div class="article-heading2" *ngIf="data.length>0 && data[activeTopicId].returnList">{{ data[activeTopicId].state}} </div>
        <div class="answwer-content" >
          <div class="col-lg-12 row file-list-section " *ngIf="data.length>0 && data[activeTopicId].returnList">
                  <div class="col-lg-6 pl-3 "  *ngFor="let item of data[activeTopicId].returnList;let i=index"
                  [ngClass]="{'border-top': i!==0 && i!==1 }">
                  <div *ngIf="router.url === '/karvy-branches'" >
                    <div class="text-answer-section top-line" >KFin Technologies Limited </div>
                    <img src="assets/icons/icon_address.png" width="4%" class="mt-2">&nbsp;
                    <div class="text-answer-section adrs-custom">

                      {{item.address}}
                    </div>
                    <div class="text-answer-section" >
                      <img src="assets/icons/icon_email_black.png" width="5%">&nbsp;
                      <u>{{item.officeEmail}} </u>
                    </div>
                    <div class="text-answer-section">
                      <img src="assets/icons/icon_phone_black.png" width="5%">&nbsp;
                      {{item.phoneNo}}
                    </div>
                    <div class="text-answer-section" *ngIf="item.contactName">
                      <img src="assets/icons/icon_name.png" width="5%">&nbsp;
                      {{item.contactName}} <br>
                      &nbsp;&nbsp;&nbsp;&nbsp;<span  *ngIf="!item.agentNo" > <u>{{item.emailId}} </u></span>
                    </div>
                  </div>
                  <div  *ngIf="router.url === '/amc-branches'">
                    <div class="text-answer-section ">
                      {{item.address}}
                    </div>
                  </div>
                  <div *ngIf="router.url === '/locate-advisor'">
                    <div class="text-answer-section" *ngIf="item.agentNo">
                      <span class="sub-header"> Agent No</span> :
                      <span class="sub-text">{{item.agentNo}}</span>
                    </div>
                    <div class="text-answer-section" *ngIf="item.agentName">
                      <span class="sub-header">Agent Name</span> :
                      <span class="sub-text">{{item.agentName}}</span>
                    </div>
                    <div class="text-answer-section" *ngIf="item.city">
                      <span class="sub-header">City </span> :
                      <span class="sub-text">{{item.city}}</span>
                    </div>
                    <div class="text-answer-section" *ngIf="item.pinCode">
                      <span class="sub-header">Pin Code</span> :
                      <span class="sub-text">{{item.pinCode}}</span>
                    </div>
                    <div class="text-answer-section" *ngIf="item.mobile">
                      <span class="sub-header">Mobile No</span> :
                      <span class="sub-text">{{item.mobile}}</span>
                    </div>
                    <div class="text-answer-section" *ngIf="item.emailId">
                      <span class="sub-header">Email </span> :
                      <span class="sub-text">{{item.emailId}}</span>
                    </div>

                  </div>
                    <br> <br>
                </div>
          </div>
          <div class="col-lg-12" *ngIf="data.length<=0 || !data[activeTopicId].returnList">
            No data available
          </div>
        </div>
      </div>
    <!-- </div> -->

</div>

